import { IAuthFromGeneric } from 'components/templates/Auth-from-generic/models/Auth-from-generic.interface';

export const headerInformation: IAuthFromGeneric['headerInformation'] = {
  title: 'BIENVENIDO/A',
  text: 'Gestiona tus planes con Connect en un solo lugar, sencillo y seguro.',
};
export const activeBenefitsHeaderInformation: IAuthFromGeneric['headerInformation'] = {
  title: 'BIENVENIDO/A',
  text: 'Regístrate para recibir tu descuento',
};